export default __webpack_public_path__ + "static/media/DEFAULT.04557a63.png";